import { Grid2 } from '@mui/material';
import FormFields from 'pages/components/FormFields';
import Section from 'pages/components/Section';

export default function References(props: any) {
  const { values, handleInputChange, isMobile, formatErrorObject, errors } =
    props;

  return (
    <Section title={'references'}>
      <Grid2
        width={'100%'}
        gap={2}
        display="grid"
        gridTemplateColumns={isMobile ? '1fr' : 'repeat(2, 1fr)'}
      >
        <FormFields.TextInput
          name="externalIdentifier"
          label={values.country + '-externalIdentifier'}
          placeholder={values.country + '-externalIdentifier'}
          value={values.externalIdentifier}
          onChange={handleInputChange}
          required
          {...formatErrorObject(errors.externalIdentifier)}
        />

        <FormFields.TextInput
          name="iban"
          value={values.iban}
          onChange={handleInputChange}
          required
          {...formatErrorObject(errors.iban)}
        />
      </Grid2>
    </Section>
  );
}
